import { React, useState, useEffect } from "react";
import PrimaryButton from "../../../../components/PrimaryButton";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Chart } from "react-google-charts";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";

const tabStyles = makeStyles({
  root: {
    minHeight: "auto",
    minWidth: "auto",
    padding: 5,
    marginRight: 15,
    textTransform: "capitalize",
    fontSize: "1.4rem",
  },
});

const useStyles = makeStyles((theme) => ({
  tab: {
    margin: "20px 0px 5px 3%",
  },
  resultsContainer: {
    marginTop: "1%",
    height: "65%",
    backgroundColor: "white",
    overflow: "scroll",
    textAlign: "center",
  },
  myButton: {
    marginTop: "2%",
    float: "right",
    marginRight: "6%",
  },
  testImage: {
    width: 200,
  },
  imagesContainer: {
    height: "30",
    overflow: "scroll",
  },
  svgImage: {
    height: 350,
  },
  chartsContainer: {
    //margin: auto
  },
}));

const Results = (props) => {
  const classes = useStyles();
  const tabClass = tabStyles();
  const [value, setValue] = useState(0);
  const [accuracyChartData, setAccuracyChartData] = useState([[]]);
  const [lossChartData, setLossChartData] = useState([[]]);
  const [svgSources, setSvgSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isProcessed, setIsProcessed] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //console.log("component re-rendered");

  async function getData() {
    let url = "";
    if (sessionStorage.getItem("classifier") === "classic") {
      const svgUrls = [];
      url = "http://superbioai.com:5000/image";

      const response = await fetch(url);
      // waits until the request completes...
      const data = await response.json();

      //do something with data

      const responseValues = Object.values(data);
      responseValues.splice(responseValues.length - 2, 2);

      responseValues.forEach((responseText) => {
        const svgText = getSvgTextFrom(responseText);
        const svgUrl = createSvgUrl(svgText);

        svgUrls.push(svgUrl);
      });

      //console.log(svgUrls);

      setTimeout(() => {
        if (svgUrls.length < 3) {
          setIsProcessed(true);
          setSvgSources(svgUrls);
        } else {
          setLoading(false);
        }
      }, 10000);

      if (svgUrls.length >= 3 && svgUrls.length !== svgSources.length) {
        setSvgSources(svgUrls);
      }
    } else if (sessionStorage.getItem("classifier") === "deep") {
      url = "http://superbioai.com:5000/graph";
      const response = await fetch(url);
      // waits until the request completes...
      const data = await response.json();

      const newAccuracyChartData = generateAccuracyDataFrom(
        data.epoch,
        data.accuracy,
        data.val_accuracy
      );

      const newLossChartData = generateLossDataFrom(
        data.epoch,
        data.loss,
        data.val_loss
      );

      setTimeout(() => {
        if (data.epoch.length < 201) {
          setAccuracyChartData(newAccuracyChartData);
          setLossChartData(newLossChartData);
        } else {
          setLoading(false);
        }
      }, 3000);

      if (
        data.epoch.length >= 201 &&
        data.epoch.length !== accuracyChartData.length - 1
      ) {
        setAccuracyChartData(newAccuracyChartData);
        setLossChartData(newLossChartData);
      }
    }
  }

  function getSvgTextFrom(str) {
    const startingIndex = str.indexOf("<svg");
    const svgText = str.substr(str.length - (str.length - startingIndex));
    return svgText;
  }

  function createSvgUrl(svgText) {
    const blob = new Blob([svgText], { type: "image/svg+xml" });
    const svgUrl = URL.createObjectURL(blob);
    return svgUrl;
  }

  function generateAccuracyDataFrom(epoch, arr1, arr2) {
    const result = [["epoch", "accuracy", "val_accuracy"]];
    for (let i = 0; i < epoch.length; i++) {
      //console.log(epoch[i], arr1[i], arr2[i]);
      result.push([epoch[i], arr1[i], arr2[i]]);
    }
    return result;
  }
  function generateLossDataFrom(epoch, arr1, arr2) {
    const result = [["epoch", "loss", "val_loss"]];
    for (let i = 0; i < epoch.length; i++) {
      //console.log(epoch[i], arr1[i], arr2[i]);
      result.push([epoch[i], arr1[i], arr2[i]]);
    }
    return result;
  }

  useEffect(getData, [svgSources, accuracyChartData]);

  return (
    <>
      <Tabs
        className={classes.tab}
        indicatorColor="secondary"
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
      >
        <Tab className={tabClass.root} label="Results" />
      </Tabs>
      <div className={classes.resultsContainer}>
        {loading && (
          <div>
            <Typography variant="h5" style={{ margin: "30px" }}>
              Preparing your model. This may take a while...{" "}
            </Typography>
            <LinearProgress />
          </div>
        )}
        {sessionStorage.getItem("classifier") === "classic" && (
          <div className={classes.imagesContainer}>
            {svgSources.map((source, index) => (
              <img
                key={index}
                className={classes.svgImage}
                src={source}
                alt=""
              />
            ))}
          </div>
        )}
        {sessionStorage.getItem("classifier") === "deep" && (
          <div className={classes.chartsContainer}>
            <Chart
              width={"600px"}
              height={"400px"}
              chartType="LineChart"
              loader={<div>Loading Chart</div>}
              data={accuracyChartData}
              options={{
                hAxis: {
                  title: "Epoch",
                },
                vAxis: {
                  title: "Accuracy",
                  //ticks: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
                },
                series: {
                  1: { curveType: "function" },
                },
              }}
              rootProps={{ "data-testid": "2" }}
              style={{ margin: "auto" }}
            />

            <Chart
              width={"600px"}
              height={"400px"}
              chartType="LineChart"
              loader={<div>Loading Chart</div>}
              data={lossChartData}
              options={{
                hAxis: {
                  title: "Epoch",
                },
                vAxis: {
                  title: "Loss",
                },
                series: {
                  1: { curveType: "function" },
                },
              }}
              rootProps={{ "data-testid": "2" }}
              style={{ margin: "auto" }}
            />
          </div>
        )}
      </div>

      <Link to="/">
        <PrimaryButton
          innerText="Save & Exit"
          styleClasses={classes.myButton}
        />
      </Link>
    </>
  );
};

export default Results;
